import { InvoiceProcessType } from "../interfaces/invoiceProcessType";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
    ? PROD_API_URL
    : DEV_API_URL;

export const getInvoiceProcessTypes = async (): Promise<
  InvoiceProcessType[]
> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  try {
    const response = await fetch(
      `${apiBaseUrl}/api/InvoiceProcessType/GetInvoiceProcessTypes`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch invoice process types");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching invoice process types:", error);
    throw error;
  }
};
